import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { InputLabel, Typography, FormHelperText, InputAdornment, IconButton, withStyles } from '@material-ui/core';
import { ContractProvider as StateProvider, ContractContext } from './contractProvider';
import { SecondaryButton, SimpleField, SelectBox, DatePicker, SingleSelect, PrimaryButton } from '../../../../../Core/Controls';
import moment from 'moment';
import { FromLoader } from '../../../../../Core/Loader/formLoader';
import { AppStorage } from '../../../../../Core/Basic/storage-service';
import EuroIcon from '@material-ui/icons/Euro';
import { CustomButtonChip } from '../../../../../Core/Controls/Inputs/DatePicker';
import DialogComp from '../../../../../Core/Dialog/DialogComp';
import DoneIcon from '@material-ui/icons/Done';
import FileUploaderButton from '../../../../../Core/Controls/GenericFileUploader';
import { useLoginInfo } from '../../../../../Core/Hooks/useLoginInfo';
const GlobalCss = withStyles({
    '@global': {
        'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        },
        '.MuiOutlinedInput-adornedStart': {
            paddingLeft: '10px'
        }
    }
})(() => null);

export const JobSingleNote = (props) => {
    const { notes } = props.note;
    return (
        <>
            <div className="single-note">
                <div className="msg" style={{ fontSize: 14, fontStyle: 'italic', cursor: 'pointer', padding: '5px 10px' }}>
                    {notes || 'N/A'}
                </div>
            </div>
        </>
    );
};

const ContractField = (props) => {
    const {
        state,
        btnLoader,
        YesNoRadio,
        dropdown,
        inputChange,
        submitData,
        tempOptions,
        singleSelectChange,
        RedirectToContract,
        showReviewModal,
        hadleSubmitReviewStatus,
        closeModal,
        onDocumentSubmit
    } = useContext(ContractContext);
    const isServiceArea = useLoginInfo().userRoles.includes('servicearea');

    let checkhaveAccess = AppStorage.getAllowAcces();

    function calculateTotalCharge(state) {
        let total = 0;

        if (state.contractPloughRequired) {
            total += Number(state.contractPloughCharge);
        }
        if (state.contractCamera) {
            total += Number(state.contractCameraCharge);
        }
        if (state.contractTracker) {
            total += Number(state.contractTrackerCharge);
        }
        if (state.contractNavigation) {
            total += Number(state.contractNavigationCharge);
        }
        if (state.contractOnboardWeighing) {
            total += Number(state.contractOnboardWeighingCharge);
        }
        if (state.contractTempProbe) {
            total += Number(state.contractTempProberCharge);
        }
        if (state.contractMOT) {
            total += Number(state.contractMOTCharge);
        }
        if (state.contractMidSeasonCalibration) {
            total += Number(state.contractMidSeasonCalibrationCharge);
        }
        if (state.contract12WeeklyBrakeRollerTests) {
            total += Number(state.contract12WeeklyBrakeRollerTestsCharge);
        }
        if (state.contractBespoke) {
            total += Number(state.contractBespokeCharge);
        }

        return total;
    }
    return (
        <>
            {state.showLoader ? (
                <FromLoader />
            ) : (
                <div>
                    <GlobalCss />
                    <Grid container spacing={1} alignItems="flex-start">
                        <Grid item xs={12} lg={7}>
                            <Grid container spacing={1} style={{ border: '1px solid rgba(0,0,0,0.2)' }}>
                                {/* <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={1}
                                        style={{ backgroundColor: '#0000000a', border: '1px solid rgba(0,0,0,0.2)', minHeight: '52px' }}
                                        alignItems="center"
                                    >
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} style={{}}>
                                            <div>Contract Ref</div>
                                            <strong style={{ cursor: 'pointer' }} onClick={RedirectToContract}>
                                                {' '}
                                                {state.vehicleData?.contractReference || 'N/A'}
                                            </strong>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} style={{}}>
                                            <div>Contract Type</div>
                                            <strong>{state.vehicleData?.contractType || 'N/A'}</strong>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} style={{}}>
                                            <div>Spreader Type</div>
                                            <strong>{state.vehicleData?.spreaderTypeDesc || 'N/A'}</strong>
                                        </Grid>
                                    </Grid>
                                </Grid> */}
                                <Grid
                                    xs={12}
                                    item
                                    container
                                    justify="space-between"
                                    style={{
                                        alignItems: 'center',
                                        padding: '5px 0px 6px 8px',
                                        borderBottom: '1px solid rgba(0,0,0,0.2)',
                                        marginBottom: '5px',
                                        paddingRight: '5px',
                                        paddingLeft: '10px'
                                    }}
                                >
                                    <Grid item xs>
                                        <Grid container spacing={1} alignItems="center">
                                            <Grid item>
                                                <Typography variant="h6" color="secondary">
                                                    Contract Details
                                                </Typography>
                                            </Grid>

                                            <Grid item>
                                                Contract Ref:{' '}
                                                <strong onClick={RedirectToContract} style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                                                    {state.vehicleData.contractReference || 'N/A'}
                                                </strong>
                                            </Grid>
                                            <Grid item>
                                                Contract Type: <strong>{state.vehicleData.contractType || 'N/A'}</strong>{' '}
                                                {state.contractTypeID == 1 && (
                                                    <>
                                                        Spreader Type: <strong>{state.vehicleData.spreaderTypeDesc || 'N/A'}</strong>
                                                    </>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item>
                                        <span title="Photo/Upload" style={{ position: 'relative', top: '-5px', left: '-5px' }}>
                                            <FileUploaderButton
                                                recordId={state.vehicleContractID}
                                                fileUploaderConfigName="VehicleContracts"
                                                fileCount={state.fileCount}
                                                isDash={true}
                                                gridRelaod={onDocumentSubmit}
                                                docName={'Documents'}
                                                fileUploaderModalClose={false}
                                            />
                                        </span>
                                    </Grid>
                                    <Grid item>
                                        <CustomButtonChip
                                            // className="btn-m"
                                            icon={DoneIcon}
                                            label={state.reviewStatus}
                                            onClick={showReviewModal}
                                            style={{ marginRight: '10px', cursor: state.reviewAllowed == 'Y' ? 'pointer' : '' }}
                                            //  disabled={state.reviewAllowed == 'N'}
                                            color={state.contractReviewStatusID == 'R' ? 'white' : 'white'}
                                            backgroundColour={state.contractReviewStatusID == 'R' ? 'green' : 'red'}
                                            iconColor={state.contractReviewStatusID == 'R' ? 'white' : 'white'}
                                            iconBg={state.contractReviewStatusID == 'R' ? 'green' : 'red'}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink error required>
                                        {state.contractTypeID == 1 ? 'Contract Commencement' : 'Start date'}
                                    </FormHelperText>
                                    <DatePicker
                                        value={state.contractStartDate && moment(state.contractStartDate).format('YYYY-MM-DD')}
                                        onChange={inputChange}
                                        name="contractStartDate"
                                        disabled={moment(state.ApiContractStartDate).isBefore(moment().format('YYYY-MM-DD'))}
                                    />
                                    <FormHelperText error>{state.errors.contractStartDate}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink>{state.contractTypeID == 1 ? 'Contract Termination Date' : 'End date'}</FormHelperText>
                                    <DatePicker
                                        value={state.contractEndDate && moment(state.contractEndDate).format('YYYY-MM-DD')}
                                        onChange={inputChange}
                                        name="contractEndDate"
                                        disabled={isServiceArea}
                                    // disabled
                                    />
                                    <FormHelperText error>{state.errors.contractEndDate}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink>Extended Date</FormHelperText>
                                    <DatePicker
                                        value={state.contractExtendedDate && moment(state.contractExtendedDate).format('YYYY-MM-DD')}
                                        onChange={inputChange}
                                        name="contractExtendedDate"
                                        disabled={isServiceArea}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
                                    <FormHelperText shrink error required>
                                        Invoice Frequency
                                    </FormHelperText>
                                    <SelectBox
                                        name="contractInvoiceFrequency"
                                        value={state.contractInvoiceFrequency}
                                        onChange={inputChange}
                                        List={[
                                            {
                                                name: 'Daily',
                                                id: 'd'
                                            },
                                            {
                                                name: 'Weekly',
                                                id: 'w'
                                            },
                                            {
                                                name: '4 Weeks',
                                                id: '4'
                                            },
                                            {
                                                name: '52 Weeks',
                                                id: '5'
                                            },
                                            {
                                                name: 'Monthly',
                                                id: 'm'
                                            },
                                            {
                                                name: 'One Off',
                                                id: 'o'
                                            },
                                            {
                                                name: 'Yearly',
                                                id: 'y'
                                            }
                                        ]}
                                        disabled={isServiceArea}
                                    />
                                    <FormHelperText error>{state.errors.contractInvoiceFrequency}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={3}>
                                    <FormHelperText shrink>Day Of Month</FormHelperText>
                                    <SimpleField
                                        onChange={inputChange}
                                        name="contractInvoiceDayOfMonth"
                                        value={state.contractInvoiceDayOfMonth}
                                        inputProps={{ maxLength: 2 }}
                                        disabled={isServiceArea}
                                    />
                                    {/* <SelectBox
                                        name="contractInvoiceDayOfMonth"
                                        value={state.contractInvoiceDayOfMonth}
                                        onChange={inputChange}
                                        List={Array.from({ length: 31 }, (_, i) => ({
                                            name: String(i + 1),
                                            id: String(i + 1)
                                        }))}
                                    /> */}
                                    <FormHelperText error>{state.errors.contractInvoiceDayOfMonth}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={state.contractTypeID == 1 ? 2 : 2}>
                                    <FormHelperText shrink>Invoice All Year</FormHelperText>
                                    <YesNoRadio
                                        name="contractInvoiceAllYear"
                                        value={state.contractInvoiceAllYear || false}
                                        onChange={inputChange}
                                        disabled={isServiceArea}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink error={state.contractTypeID == 1} required={state.contractTypeID == 1}>
                                        Purchase Order
                                    </FormHelperText>
                                    <SimpleField
                                        onChange={inputChange}
                                        name="contractPurchaseOrder"
                                        value={state.contractPurchaseOrder}
                                        inputProps={{ maxLength: 32 }}
                                        disabled={isServiceArea}
                                    />
                                    <FormHelperText error>{state.errors.contractPurchaseOrder}</FormHelperText>
                                </Grid>
                                {state.contractTypeID == 1 && (
                                    <>
                                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                            <FormHelperText shrink error required>
                                                Winter Start Date
                                            </FormHelperText>
                                            <DatePicker
                                                value={state.contractWinterStartDate && moment(state.contractWinterStartDate).format('YYYY-MM-DD')}
                                                onChange={inputChange}
                                                name="contractWinterStartDate"
                                                // disabled={moment(state.ApicontractWinterStartDate).isBefore(moment().format('YYYY-MM-DD'))}
                                                disabled={state.vehicleContractStatusID > 6 || isServiceArea}
                                            />
                                            <FormHelperText error>{state.errors.contractWinterStartDate}</FormHelperText>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                            <FormHelperText shrink error required>
                                                Winter Term (Weeks)
                                            </FormHelperText>
                                            <SimpleField
                                                onChange={inputChange}
                                                name="contractWinterTerms"
                                                value={state.contractWinterTerms}
                                                disabled={moment(state.ApicontractWinterStartDate).isBefore(moment().format('YYYY-MM-DD')) || isServiceArea}
                                            />
                                            <FormHelperText error>{state.errors.contractWinterTerms}</FormHelperText>
                                        </Grid>

                                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                            <FormHelperText shrink>Winter Charge End Date</FormHelperText>
                                            <DatePicker
                                                value={state.contractWinterEndDate && moment(state.contractWinterEndDate).format('YYYY-MM-DD')}
                                                onChange={inputChange}
                                                name="contractWinterEndDate"
                                                // disabled={!state.isWinterChargeEndDateEditable}
                                                disabled
                                            />
                                            <FormHelperText error>{state.errors.contractWinterEndDate}</FormHelperText>
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                            <FormHelperText shrink>Winter Off Hire Date</FormHelperText>
                                            <DatePicker
                                                value={state.contractOffhireDate && moment(state.contractOffhireDate).format('YYYY-MM-DD')}
                                                onChange={inputChange}
                                                name="contractOffhireDate"
                                                disabled
                                            />
                                            <FormHelperText error>{state.errors.contractOffhireDate}</FormHelperText>
                                        </Grid>
                                    </>
                                )}

                                {/* <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                            <FormHelperText shrink>Mileage (KMs)</FormHelperText>
                            <SimpleField onChange={inputChange} name="contractMileage" value={state.contractMileage} />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                            <FormHelperText shrink>Excess Mileage (pence per KM)</FormHelperText>
                            <SimpleField onChange={inputChange} name="contractExcessMileage" value={state.contractExcessMileage} />
                        </Grid> 
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                            <FormHelperText shrink>Weekly Rental</FormHelperText>
                            <SimpleField onChange={inputChange} name="contractWeeklyRental" value={state.contractWeeklyRental} />
                        </Grid> */}

                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink>Annual Price Increase</FormHelperText>
                                    <YesNoRadio
                                        name="contractAnnualPriceIncrease"
                                        value={state.contractAnnualPriceIncrease || false}
                                        onChange={inputChange}
                                        disabled={isServiceArea}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink>Increase %</FormHelperText>
                                    <SimpleField
                                        type="number"
                                        onChange={inputChange}
                                        name="contractIncreaseAmount"
                                        value={state.contractIncreaseAmount}
                                        disabled={isServiceArea}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                    <FormHelperText shrink>Increase Date</FormHelperText>
                                    <DatePicker
                                        value={state.contractIncreaseDate && moment(state.contractIncreaseDate).format('YYYY-MM-DD')}
                                        onChange={inputChange}
                                        name="contractIncreaseDate"
                                        disabled={isServiceArea}
                                    />
                                </Grid>
                                {state.contractTypeID == 1 && (
                                    <Grid item xs={12} sm={4} md={4} lg={6} xl={4}>
                                        <FormHelperText shrink>Framework</FormHelperText>
                                        <SimpleField
                                            onChange={inputChange}
                                            name="contractFramework"
                                            value={state.contractFramework}
                                            inputProps={{ maxLength: 50 }}
                                            disabled={isServiceArea}
                                        />
                                        <FormHelperText error>{state.errors.contractFramework}</FormHelperText>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={12}>
                                    <hr />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} className="mandatory-fields">
                                    <FormHelperText required shrink error>
                                        Depot
                                    </FormHelperText>
                                    <SingleSelect
                                        name="contractDepotID"
                                        options={dropdown.depotsList || []}
                                        value={tempOptions.contractDepotID}
                                        onChange={singleSelectChange('contractDepotID')}
                                    />
                                    <FormHelperText error>{state.errors.contractDepotID}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                    <FormHelperText shrink error required>
                                        Service Area
                                    </FormHelperText>
                                    <SingleSelect
                                        name="contractServiceAreaID"
                                        value={tempOptions.contractServiceAreaID}
                                        onChange={singleSelectChange('contractServiceAreaID')}
                                        options={dropdown.serviceAgents}
                                        disabled={isServiceArea}
                                    />
                                    <FormHelperText error>{state.errors.contractServiceAreaID}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} sm={4} md={4}>
                                    <FormHelperText
                                        shrink
                                    // error={state.contractTypeID == 2} required={state.contractTypeID == 2}
                                    >
                                        Engineer
                                    </FormHelperText>
                                    <SingleSelect
                                        name="contractEngineerUserID"
                                        value={tempOptions.contractEngineerUserID}
                                        onChange={singleSelectChange('contractEngineerUserID')}
                                        options={dropdown.technicianList}
                                    />
                                    {/* <FormHelperText error>{state.errors.contractEngineerUserID}</FormHelperText> */}
                                </Grid>
                                {state.contractTypeID == 1 && (
                                    <Grid item xs={12} sm={4} md={4}>
                                        <FormHelperText shrink error required>
                                            Summer Service Area
                                        </FormHelperText>
                                        <SingleSelect
                                            name="contractSummerServiceAreaID"
                                            value={tempOptions.contractSummerServiceAreaID}
                                            onChange={singleSelectChange('contractSummerServiceAreaID')}
                                            options={dropdown.serviceAgents}
                                            disabled={isServiceArea}
                                        />
                                        <FormHelperText error>{state.errors.contractSummerServiceAreaID}</FormHelperText>
                                    </Grid>
                                )}

                                <Grid item xs={12} sm={12}>
                                    <hr />
                                </Grid>
                                {/* <Grid item xs={12}>
                            <Grid container spacing={1}> */}
                                {state.contractTypeID == 1 && (
                                    <Grid item xs={12}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={2} lg={3} xl={2}>
                                                        <FormHelperText shrink error required>
                                                            Delivery Charge
                                                        </FormHelperText>
                                                        <SimpleField
                                                            type="number"
                                                            onChange={inputChange}
                                                            name="contractDeliveryCharge"
                                                            value={state.contractDeliveryCharge}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        {/* <EuroIcon color="secondary" /> */}
                                                                        <Typography color="secondary" variant="h6">
                                                                            £
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                            disabled={isServiceArea}
                                                        />
                                                        <FormHelperText error>{state.errors.contractDeliveryCharge}</FormHelperText>
                                                    </Grid>
                                                    <Grid item xs={12} sm={2} lg={3} xl={2}>
                                                        <FormHelperText shrink error required>
                                                            Collection Charge
                                                        </FormHelperText>
                                                        {/* <FormHelperText shrink error required>
                                                            Collection Charge
                                                        </FormHelperText> */}
                                                        <SimpleField
                                                            type="number"
                                                            onChange={inputChange}
                                                            name="contractCollectionCharge"
                                                            value={state.contractCollectionCharge}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        {/* <EuroIcon color="secondary" /> */}
                                                                        <Typography color="secondary" variant="h6">
                                                                            £
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                            disabled={isServiceArea}
                                                        />
                                                        <FormHelperText error>{state.errors.contractCollectionCharge}</FormHelperText>
                                                    </Grid>
                                                    <Grid item xs={12} sm={2} lg={3} xl={2}>
                                                        <FormHelperText shrink>Collection Charge Date</FormHelperText>
                                                        {/* <FormHelperText shrink>Collection Charge Date</FormHelperText> */}
                                                        <DatePicker
                                                            value={
                                                                state.contractCollectionChargeDate &&
                                                                moment(state.contractCollectionChargeDate).format('YYYY-MM-DD')
                                                            }
                                                            onChange={inputChange}
                                                            name="contractCollectionChargeDate"
                                                            disabled={isServiceArea}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={2} lg={3} xl={2}>
                                                        <FormHelperText shrink error required>
                                                            Rate (Weekly)
                                                        </FormHelperText>
                                                        <SimpleField
                                                            type="number"
                                                            onChange={inputChange}
                                                            name="contractWeeklyRental"
                                                            value={state.contractWeeklyRental}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        {/* <EuroIcon color="secondary" /> */}
                                                                        <Typography color="secondary" variant="h6">
                                                                            £
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                            disabled={isServiceArea}
                                                        />
                                                        <FormHelperText error>{state.errors.contractWeeklyRental}</FormHelperText>
                                                    </Grid>
                                                    <Grid item xs={4} md lg={3} xl={2}>
                                                        <FormHelperText shrink>Rate Daily</FormHelperText>
                                                        <div
                                                            style={{
                                                                fontSize: '18px',
                                                                height: '40px',
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}
                                                            disabled={isServiceArea}
                                                        >
                                                            £{Number(state.contractWeeklyRental / 7).toFixed(2)}
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4} md lg={3} xl={2}>
                                                        <FormHelperText shrink>Weekly Total</FormHelperText>
                                                        <div
                                                            style={{
                                                                fontSize: '18px',
                                                                height: '40px',
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            £{(Number(state.contractWeeklyRental) + calculateTotalCharge(state)).toFixed(2)}
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={12} sm={2} lg={3} xl={2}>
                                                        <FormHelperText shrink>Offhire Override</FormHelperText>
                                                        {/* <SimpleField onChange={inputChange} name="contractOffhireOverride" value={state.contractOffhireOverride} />
                                                         <FormHelperText error>{state.errors.contractOffhireOverride}</FormHelperText> */}
                                                        <YesNoRadio
                                                            name="contractOffhireOverride"
                                                            value={state.contractOffhireOverride || false}
                                                            onChange={inputChange}
                                                            disabled={isServiceArea}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2} lg={3} xl={2}>
                                                        <FormHelperText shrink>Mileage (KMs)</FormHelperText>
                                                        <SimpleField
                                                            onChange={inputChange}
                                                            name="contractMileage"
                                                            value={state.contractMileage}
                                                            disabled={isServiceArea}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2} lg={3} xl={3}>
                                                        <FormHelperText shrink>Excess Mileage</FormHelperText>
                                                        <SimpleField onChange={inputChange} name="contractExcessMileage" value={state.contractExcessMileage} disabled={isServiceArea} placeholder="pence per KM" />
                                                    </Grid>

                                                    <Grid item xs={12} sm={2} lg={3} xl={3}>
                                                        <FormHelperText shrink>Summer Rate (Weekly)</FormHelperText>
                                                        <SimpleField
                                                            type="number"
                                                            onChange={inputChange}
                                                            name="contractSummerWeeklyRate"
                                                            value={state.contractSummerWeeklyRate}
                                                            disabled={isServiceArea}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <Typography color="secondary" variant="h6">
                                                                            £
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={2} lg={3} xl={3}>
                                                        <FormHelperText shrink>Summer Rate Date</FormHelperText>
                                                        <DatePicker
                                                            value={state.contractSummerRateStartDate && moment(state.contractSummerRateStartDate).format('YYYY-MM-DD')}
                                                            onChange={inputChange}
                                                            name="contractSummerRateStartDate"
                                                            disabled={isServiceArea}
                                                        />
                                                    </Grid>
                                                    {/* <Grid item xs={12} sm={3} md lg={'auto'} xl={'auto'}>
                                                        <FormHelperText shrink>Delivery Arranged?</FormHelperText>
                                                        <YesNoRadio
                                                            name="contractDeliveryArranged"
                                                            value={state.contractDeliveryArranged || false}
                                                            onChange={inputChange}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md lg xl>
                                                        <FormHelperText shrink>Delivery Date</FormHelperText>
                                                        <DatePicker
                                                            value={state.contractDeliveryDate && moment(state.contractDeliveryDate).format('YYYY-MM-DD')}
                                                            onChange={inputChange}
                                                            name="contractDeliveryDate"
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={3} md lg xl>
                                                        <FormHelperText shrink>Onsite Date</FormHelperText>
                                                        <DatePicker
                                                            value={state.contractOnsiteDate && moment(state.contractOnsiteDate).format('YYYY-MM-DD')}
                                                            onChange={inputChange}
                                                            name="contractOnsiteDate"
                                                        />
                                                    </Grid> */}
                                                </Grid>
                                            </Grid>

                                            {/*<Grid item xs={6}>
                                                <Grid container spacing={1}>
                                                     <Grid item xs={12} sm={3} md lg={'auto'} xl={'auto'}>
                                                        <FormHelperText shrink>Collection Arranged?</FormHelperText>
                                                        
                                                        <YesNoRadio
                                                            name="contractCollectionArranged"
                                                            value={state.contractCollectionArranged || false}
                                                            onChange={inputChange}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md lg xl>
                                                        <FormHelperText shrink>Collection Date</FormHelperText>
                                                        <DatePicker
                                                            value={state.contractCollectionDate && moment(state.contractCollectionDate).format('YYYY-MM-DD')}
                                                            onChange={inputChange}
                                                            name="contractCollectionDate"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3} md lg xl>
                                                        <FormHelperText shrink>Return Date</FormHelperText>
                                                        <DatePicker
                                                            value={state.contractReturnDate && moment(state.contractReturnDate).format('YYYY-MM-DD')}
                                                            onChange={inputChange}
                                                            name="contractReturnDate"
                                                        />
                                                    </Grid> 
                                                </Grid>
                                            </Grid>*/}
                                            {/* <Grid item xs={12}>
                                                <Grid container spacing={1}></Grid>
                                            </Grid> */}
                                        </Grid>
                                    </Grid>
                                )}
                                {state.contractTypeID == 2 && (
                                    <>
                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                            <FormHelperText shrink>Annual Rate</FormHelperText>
                                            <SimpleField
                                                type="number"
                                                onChange={inputChange}
                                                name="contractAnnualRate"
                                                value={state.contractAnnualRate}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            {/* <EuroIcon color="secondary" /> */}
                                                            <Typography color="secondary" variant="h6">
                                                                £
                                                            </Typography>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                disabled={isServiceArea}
                                            />
                                            <FormHelperText error>{state.errors.contractAnnualRate}</FormHelperText>
                                        </Grid>
                                    </>
                                )}

                                {/* </Grid>
                        </Grid> */}

                                <Grid item xs={12} sm={12}>
                                    <hr />
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={1}>
                                        {state.contractTypeID == 1 && (
                                            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={12}>
                                                        <FormHelperText shrink>Plough Required?</FormHelperText>
                                                        <Grid container>
                                                            <Grid item xs>
                                                                <YesNoRadio
                                                                    name="contractPloughRequired"
                                                                    value={state.contractPloughRequired || false}
                                                                    onChange={inputChange}
                                                                    disabled={isServiceArea}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractPloughCharge"
                                                                    value={state.contractPloughCharge}
                                                                    disabled={isServiceArea}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <FormHelperText error>{state.errors.contractPloughRequired}</FormHelperText>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <FormHelperText shrink>Plough </FormHelperText>
                                                        <SimpleField
                                                            onChange={inputChange}
                                                            name="contractPloughDescription"
                                                            value={state.contractPloughDescription}
                                                            disabled={isServiceArea}
                                                        />
                                                        <FormHelperText error>{state.errors.contractPloughDescription}</FormHelperText>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                            <Grid container spacing={1} alignItems="flex-end">
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Camera</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                onChange={inputChange}
                                                                name="contractCamera"
                                                                value={state.contractCamera}
                                                                disabled={isServiceArea}
                                                            />
                                                        </Grid>
                                                        {state.contractTypeID == 1 && (
                                                            <Grid item xs={4}>
                                                                {' '}
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractCameraCharge"
                                                                    value={state.contractCameraCharge}
                                                                    disabled={isServiceArea}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    <FormHelperText error>{state.errors.contractCamera}</FormHelperText>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Camera </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        name="contractCameraDescription"
                                                        value={state.contractCameraDescription}
                                                        disabled={isServiceArea}
                                                    />
                                                    <FormHelperText error>{state.errors.contractCameraDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Tracker</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                onChange={inputChange}
                                                                name="contractTracker"
                                                                value={state.contractTracker}
                                                                disabled={isServiceArea}
                                                            />
                                                        </Grid>
                                                        {state.contractTypeID == 1 && (
                                                            <Grid item xs={4}>
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractTrackerCharge"
                                                                    value={state.contractTrackerCharge}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                    disabled={isServiceArea}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    <FormHelperText error>{state.errors.contractTracker}</FormHelperText>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Tracker </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        name="contractTrackerDescription"
                                                        value={state.contractTrackerDescription}
                                                        disabled={isServiceArea}
                                                    />
                                                    <FormHelperText error>{state.errors.contractTrackerDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Navigation?</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                name="contractNavigation"
                                                                value={state.contractNavigation || false}
                                                                onChange={inputChange}
                                                                disabled={isServiceArea}
                                                            />
                                                        </Grid>
                                                        {state.contractTypeID == 1 && (
                                                            <Grid item xs={4}>
                                                                {' '}
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractNavigationCharge"
                                                                    value={state.contractNavigationCharge}
                                                                    disabled={isServiceArea}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    <FormHelperText error>{state.errors.contractNavigationCharge}</FormHelperText>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Navigation </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        name="contractNavigationDescription"
                                                        value={state.contractNavigationDescription}
                                                        disabled={isServiceArea}
                                                    />
                                                    <FormHelperText error>{state.errors.contractNavigationDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Onboard Weighing?</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                name="contractOnboardWeighing"
                                                                value={state.contractOnboardWeighing || false}
                                                                onChange={inputChange}
                                                                disabled={isServiceArea}
                                                            />
                                                        </Grid>
                                                        {state.contractTypeID == 1 && (
                                                            <Grid item xs={4}>
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractOnboardWeighingCharge"
                                                                    value={state.contractOnboardWeighingCharge}
                                                                    disabled={isServiceArea}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    <FormHelperText error>{state.errors.contractOnboardWeighingCharge}</FormHelperText>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Onboard Weighing </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        name="contractOnboardWeighingDescription"
                                                        value={state.contractOnboardWeighingDescription}
                                                        disabled={isServiceArea}
                                                    />
                                                    <FormHelperText error>{state.errors.contractOnboardWeighingDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {/* </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container spacing={1} alignItems="flex-end"> */}
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Temp Probe?</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                name="contractTempProbe"
                                                                value={state.contractTempProbe || false}
                                                                onChange={inputChange}
                                                                disabled={isServiceArea}
                                                            />
                                                        </Grid>
                                                        {state.contractTypeID == 1 && (
                                                            <Grid item xs={4}>
                                                                {' '}
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractTempProberCharge"
                                                                    value={state.contractTempProberCharge}
                                                                    disabled={isServiceArea}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Temp Probe </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        disabled={isServiceArea}
                                                        name="contractTempProberDescription"
                                                        value={state.contractTempProberDescription}
                                                    />
                                                    <FormHelperText error>{state.errors.contractTempProberDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {state.contractTypeID == 1 && (
                                            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={12}>
                                                        <FormHelperText shrink>MOT</FormHelperText>
                                                        <Grid container>
                                                            <Grid item xs>
                                                                <YesNoRadio
                                                                    onChange={inputChange}
                                                                    disabled={isServiceArea}
                                                                    name="contractMOT"
                                                                    value={state.contractMOT}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    disabled={isServiceArea}
                                                                    name="contractMOTCharge"
                                                                    value={state.contractMOTCharge}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                        <FormHelperText error>{state.errors.contractMOT}</FormHelperText>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <FormHelperText shrink>MOT </FormHelperText>
                                                        <SimpleField
                                                            onChange={inputChange}
                                                            name="contractMOTDescription"
                                                            disabled={isServiceArea}
                                                            value={state.contractMOTDescription}
                                                        />
                                                        <FormHelperText error>{state.errors.contractMOTDescription}</FormHelperText>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Mid Season Calibration?</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                name="contractMidSeasonCalibration"
                                                                value={state.contractMidSeasonCalibration || false}
                                                                disabled={isServiceArea}
                                                                onChange={inputChange}
                                                            />
                                                        </Grid>
                                                        {state.contractTypeID == 1 && (
                                                            <Grid item xs={4}>
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contractMidSeasonCalibrationCharge"
                                                                    disabled={isServiceArea}
                                                                    value={state.contractMidSeasonCalibrationCharge}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} sm={12}>
                                                    <FormHelperText shrink>Mid Season Calibration </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        name="contractMidSeasonCalibrationDescription"
                                                        value={state.contractMidSeasonCalibrationDescription}
                                                        disabled={isServiceArea}
                                                    />
                                                    <FormHelperText error>{state.errors.contractMidSeasonCalibrationDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {state.contractTypeID == 1 && (
                                            <Grid item xs={12} sm={6} md={4} lg={3} xl={6}>
                                                <Grid container spacing={1}>
                                                    <Grid item xs={12} sm={12} xl={6}>
                                                        <FormHelperText shrink>12 Weekly Brake Roller Test?</FormHelperText>
                                                        <Grid container>
                                                            <Grid item xs>
                                                                <YesNoRadio
                                                                    name="contract12WeeklyBrakeRollerTests"
                                                                    value={state.contract12WeeklyBrakeRollerTests || false}
                                                                    onChange={inputChange}
                                                                    disabled={isServiceArea}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <SimpleField
                                                                    type="number"
                                                                    onChange={inputChange}
                                                                    name="contract12WeeklyBrakeRollerTestsCharge"
                                                                    value={state.contract12WeeklyBrakeRollerTestsCharge}
                                                                    disabled={isServiceArea}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <InputAdornment position="start">
                                                                                <Typography color="secondary" variant="h6">
                                                                                    £
                                                                                </Typography>
                                                                            </InputAdornment>
                                                                        )
                                                                    }}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} xl={6}>
                                                        <FormHelperText shrink>12 Weekly Brake Roller Test </FormHelperText>
                                                        <SimpleField
                                                            onChange={inputChange}
                                                            disabled={isServiceArea}
                                                            name="contract12WeeklyBrakeRollerTestsDescription"
                                                            value={state.contract12WeeklyBrakeRollerTestsDescription}
                                                        />
                                                        <FormHelperText error>{state.errors.contract12WeeklyBrakeRollerTestsDescription}</FormHelperText>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Grid item xs={12} sm={6} md={4} lg={3} xl={6}>
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={12} xl={6}>
                                                    <FormHelperText shrink>Bespoke</FormHelperText>
                                                    <Grid container>
                                                        <Grid item xs>
                                                            <YesNoRadio
                                                                onChange={inputChange}
                                                                name="contractBespoke"
                                                                value={state.contractBespoke}
                                                                disabled={isServiceArea}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={4}>
                                                            <SimpleField
                                                                type="number"
                                                                onChange={inputChange}
                                                                name="contractBespokeCharge"
                                                                value={state.contractBespokeCharge}
                                                                disabled={isServiceArea}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            {/* <EuroIcon color="secondary" /> */}
                                                                            <Typography color="secondary" variant="h6">
                                                                                £
                                                                            </Typography>
                                                                        </InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                    <FormHelperText error>{state.errors.contractBespoke}</FormHelperText>
                                                </Grid>
                                                <Grid item xs={12} sm={12} xl={6}>
                                                    <FormHelperText shrink>Bespoke </FormHelperText>
                                                    <SimpleField
                                                        onChange={inputChange}
                                                        name="contractBespokeDescription"
                                                        value={state.contractBespokeDescription}
                                                        disabled={isServiceArea}
                                                    />
                                                    <FormHelperText error>{state.errors.contractBespokeDescription}</FormHelperText>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {state.contractTypeID == 2 && (
                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                <FormHelperText shrink>Cab Beacons</FormHelperText>
                                                <YesNoRadio
                                                    name="contractCabBeacons"
                                                    value={state.contractCabBeacons || false}
                                                    onChange={inputChange}
                                                    disabled={isServiceArea}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12} lg={12} xl={12} className="mandatory-fields">
                                            <SimpleField
                                                multiline
                                                rows={10}
                                                FormHelperText="Notes"
                                                disabled={state.disabled || isServiceArea}
                                                placeholder="Notes"
                                                value={state.contractNotes}
                                                onChange={inputChange}
                                                name="contractNotes"

                                            // errors={state.errors.contractDescription}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={5} style={{ marginTop: '-3px' }}>
                            <div className="single-note">
                                <div
                                    className="msg"
                                    style={{
                                        fontSize: 16,
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        padding: '5px 10px',
                                        backgroundColor: '#F5F5F5',
                                        border: '1px solid rgba(0,0,0,0.2)',
                                        height: '32px'
                                    }}
                                >
                                    History
                                </div>
                            </div>
                            <div
                                style={{
                                    padding: '5px',
                                    minHeight: '430px',
                                    // maxHeight: '430px',
                                    // height: 'calc(100vh - 240px)',
                                    overflow: 'auto',
                                    border: '1px solid rgba(0,0,0,0.2)'
                                }}
                            >
                                {state.contractNotesList.length > 0 ? (
                                    <>
                                        {state.contractNotesList?.map((n, i) => (
                                            <div style={{ background: i % 2 ? '#F6EEEC' : '#ECF4F6', padding: '5px 10px' }}>
                                                <JobSingleNote key={i} note={n} />
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    <div style={{ background: '#ECF4F6', padding: '5px 10px' }}>No Record Found</div>
                                )}
                            </div>
                        </Grid>
                    </Grid>

                    <br />
                    <Grid container spacing={1}>
                        <Grid item xs={props.vehicleContractID ? 12 : 6} className="submit_btn">
                            <SecondaryButton
                                isBtnLoader={btnLoader}
                                onClick={submitData}
                                // disabled={!(checkhaveAccess?.CanUpdateContracts && checkhaveAccess?.CanAddContracts)}
                                disabled={
                                    isServiceArea
                                        ? false
                                        : !checkhaveAccess[`${state.contractTypeID == 1 ? 'CanUpdateHireContracts' : 'CanUpdateMaintenanceContracts'}`]
                                }
                            >
                                {props.vehicleContractID ? 'Update' : 'Submit'}
                            </SecondaryButton>
                        </Grid>
                        <Grid item xs={6} className="submit_btn" style={{ display: props.vehicleContractID ? 'none' : 'block' }}>
                            <SecondaryButton onClick={props.onClose} forceEnabled={true}>
                                Cancel
                            </SecondaryButton>
                        </Grid>
                    </Grid>
                </div>
            )}
            {state.showReview ? (
                <DialogComp title={`Review Status`} onClose={() => closeModal(false)} maxWidth="sm" fullWidth>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography component="legend">Are you sure you wish to mark this contract as reviewed?</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <PrimaryButton isBtnLoader={btnLoader} onClick={hadleSubmitReviewStatus} disabled={!checkhaveAccess?.CanUpdateContracts}>
                                Yes
                            </PrimaryButton>
                        </Grid>
                        <Grid item xs={6}>
                            <SecondaryButton isBtnLoader={btnLoader} onClick={() => closeModal(false)} disabled={!checkhaveAccess?.CanUpdateContracts}>
                                No
                            </SecondaryButton>
                        </Grid>
                    </Grid>
                </DialogComp>
            ) : null}
        </>
    );
};
const Screen = (props) => {
    return (
        <StateProvider {...props}>
            <ContractField {...props} />
        </StateProvider>
    );
};

export default Screen;
